// extracted by mini-css-extract-plugin
export default {"headerButton":"TemplatesView_headerButton__AQFK3","headerElement":"TemplatesView_headerElement__GprL8"};